import { useRecoilState } from "recoil";
import { ModalTypeState, SelectedAssetState } from "../../atoms";
import { BaseModal } from "./BaseModal";
import { AssetsClient } from "../../services";
import { GetNewInstance } from "../../helpers/HttpCommon";
import { ModalTypes } from "./ModalTypes";
import { Store } from "../../helpers";
import { toast } from "react-toastify";
import { SpinnerButton } from "../buttons";
import { useState } from "react";

type Props = {
  onSuccess: () => void;
};

export function DeleteAssetModal({ onSuccess }: Props) {
  const [, setModalType] = useRecoilState(ModalTypeState);
  const [selectedAsset, setSelectedAsset] = useRecoilState(SelectedAssetState);
  const [showSpinner, setShowSpinner] = useState(false);

  const client = new AssetsClient(undefined, GetNewInstance());
  const usersCustomerId = Store.getCustomerId();

  const onCancel = () => {
    setSelectedAsset(null);
    setModalType(null);
  };

  const onDeleteClick = () => {
    if (usersCustomerId && selectedAsset) {
      setShowSpinner(true);
      client
        .deleteAsset(usersCustomerId, selectedAsset)
        .then((x) => {
          toast.success("Asset deleted successfully");
          onSuccess();
        })
        .finally(() => {
          setSelectedAsset(null);
          setModalType(null);
          setShowSpinner(false);
        });
    }
  };

  return (
    <BaseModal
      id={ModalTypes.DeleteAssetModal}
      title="Delete asset"
      description={`Are you sure you want to delete the asset? Playlists and schedules associated with the asset will be affected.`}
    >
      <div className="py-4 text-sm text-white">
        <div className="mt-8 flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="py-2.5 px-4 rounded-md border border-page-border bg-white bg-opacity-5 hover:bg-opacity-10"
          >
            Cancel
          </button>
          <SpinnerButton
            onClick={onDeleteClick}
            className="py-2.5 px-4 rounded-md bg-button-bg-destructive-default hover:bg-button-bg-destructive-hover active:shadow-button-bg-destructive-default"
            showSpinner={showSpinner}
          >
            Delete
          </SpinnerButton>
        </div>
      </div>
    </BaseModal>
  );
}
